import React, { useState, useEffect, useRef } from "react";
import UiTopRightSection from "./UiTopRightSection";
import { UiProfileInfo } from "../../../../pages/auth/view/UiProfileInfo";


export default function UiTopNavProfile(props) {
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const newRef = useRef(null);
    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
          document.removeEventListener("mousedown", handleOutsideClick);
        };
      });

      const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            setShowProfileMenu(false);
        }
      };

    const showProfile = () => {
        setShowProfileMenu(!showProfileMenu);

    };

    const closeProfile = () => {
        setShowProfileMenu(false);

    }

    return (
        <>
            <div className="sb-top-nav-wr__profile-area">
                    <UiTopRightSection showProfile={showProfile} />
                <div className={showProfileMenu ? 'sb-top-nav-wr__profile-expanded show-profile-div' : 'sb-top-nav-wr__profile-expanded'} ref={newRef}>
                    <UiProfileInfo closeProfile={showProfile} show={showProfileMenu}/>
                </div>
            </div>
        </>
    );
}
